import { useEffect, useState } from 'react';
import { Table } from 'antd';
import styles from './index.module.scss';
import SupportTitleH5 from '@/componentsH5/SupportCommon/SupportTitle';
import SupportContactUsH5 from '@/componentsH5/SupportCommon/SupportContactUs';
import { useGlobal } from '@/utils/useGlobal';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';

const SupportPolicy = ({ lang, policyData }: any) => {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const [navList, setNavList] = useState<string[]>([]);
    const [isShowNav, setIsShowNav] = useState(false);
    const [activeNav, setActiveNav] = useState(0);

    const handleChangeActive = (index: number) => {
        setActiveNav(index);
        setIsShowNav(false);
    };

    const createdTable = (tableColumn?: string[], tableData?: string[][], className = '') => {
        if (!tableColumn || !tableData) return <div></div>;

        const columns = tableColumn.map((item) => {
            if (locale === 'sa' && className === 'table-1-2' && item === 'Accessories') {
                return {
                    title: item,
                    dataIndex: item,
                    key: item,
                    render: (_val: any, _row: any, _i: number) => {
                        const obj = {
                            children: _val,
                            props: { rowSpan: 0 },
                        };
                        if (_i === 0) {
                            obj.props.rowSpan = 10;
                        }
                        return obj;
                    },
                };
            }
            if (locale === 'sa' && className === 'table-1-3' && item === 'Products') {
                return {
                    title: item,
                    dataIndex: item,
                    key: item,
                    render: (_val: any, _row: any, _i: number) => {
                        const obj = {
                            children: _val,
                            props: { rowSpan: 0 },
                        };
                        if (_i === 0) {
                            obj.props.rowSpan = 9;
                        }
                        if (_i === 9) {
                            obj.props.rowSpan = 7;
                        }
                        if (_i === 16) {
                            obj.props.rowSpan = 6;
                        }
                        if (_i === 22) {
                            obj.props.rowSpan = 6;
                        }
                        if (_i === 28) {
                            obj.props.rowSpan = 1;
                        }
                        return obj;
                    },
                };
            }
            return {
                title: item,
                dataIndex: item,
                key: item,
            };
        });
        const data = tableData.map((item, rowIndex) => {
            const rowData = {} as Record<string, string | number>;
            rowData['key'] = rowIndex;
            tableColumn.map((key, index) => {
                rowData[key] = item[index] || '--';
            });
            return rowData;
        });
        return <Table className={className} columns={columns} dataSource={data} pagination={false} bordered={true} />;
    };

    useEffect(() => {
        const navList = Object.keys(policyData);
        setNavList(navList);
        setActiveNav(0);
    }, [policyData]);

    return (
        <div className={styles.SupportPolicyMobile}>
            <div className="accessories-box">
                <SupportTitleH5 title={lang.title} lang={lang} />
                <div className={`policy-access-tab-top ${isShowNav ? 'nav-active' : ''}`} onMouseLeave={() => setIsShowNav(false)}>
                    <div className="policy-access-tab-top-wrapper" onClick={() => setIsShowNav(!isShowNav)}>
                        <span className="anchor-text">{navList[activeNav]}</span>
                        <div className="iconBox">
                            <EFArrowDown />
                        </div>
                    </div>
                    {isShowNav && (
                        <div className="vertical-nav">
                            <ul>
                                {navList.map((item: string, index: number) => (
                                    <li key={index} className={activeNav === index ? 'active' : ''} onClick={() => handleChangeActive(index)}>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
                <div className="policy-access-content">
                    <h3>
                        {activeNav + 1}.&nbsp;&nbsp;{navList[activeNav]}
                    </h3>
                    {policyData[navList[activeNav]] &&
                        policyData[navList[activeNav]].map((item: any, index: number) => {
                            return (
                                <div key={index}>
                                    {item.title && (
                                        <h5>
                                            {activeNav + 1}.{index + 1}&nbsp;&nbsp;{item.title}
                                        </h5>
                                    )}
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: item.content,
                                        }}
                                        style={{ color: '#35404e', marginBottom: item.tableData && item.tableData.length ? '0.16rem' : '' }}
                                    ></div>
                                    {createdTable(item.tableColumn, item.tableData, item.className)}
                                    {item.tips && (
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: item.tips,
                                            }}
                                            style={{ marginTop: item.tableData && item.tableData.length ? '0.16rem' : '' }}
                                        ></div>
                                    )}
                                </div>
                            );
                        })}
                </div>
                <SupportContactUsH5 isShow={true} />
            </div>
            <div></div>
        </div>
    );
};

export default SupportPolicy;
